import type { MarkerArea, MarkerBase } from '@markerjs/markerjs3'
import { ref } from 'vue'

export function useAnnotationLayer() {
  const activeMarker = ref<null | MarkerArea>(null)
  const activeTool = ref<null | typeof MarkerBase | string>(null)
  const isVisibleMenu = ref(false)
  const scalingMode = ref<'fit-content' | 'fit-width' | 'fit-height'>('fit-content')

  // Switch between viewing (slide interaction) and editing (tools interaction)
  const enablePointerEventsInSvg = (value = true) => {
    // @ts-expect-error check if _mainCanvas is defined
    if (!activeMarker.value?._mainCanvas?.style) return

    // @ts-expect-error toggle interaction with the canvas (viewing vs editing)
    activeMarker.value._mainCanvas.style.pointerEvents = value ? 'auto' : 'none'
  }

  const setActiveMarker = (marker: null | MarkerArea) => {
    if (activeMarker.value) {
      clearSelection()
    }

    activeMarker.value = marker
    triggerToolUpdate()
  }

  const setActiveTool = (tool: null | typeof MarkerBase | string) => {
    activeTool.value = tool
    triggerToolUpdate()
  }

  const triggerToolUpdate = () => {
    if (!activeMarker.value) {
      return
    }

    if (!activeTool.value) {
      enablePointerEventsInSvg(false)

      return
    }

    enablePointerEventsInSvg(true)

    if (activeTool.value === 'selection') {
      activeMarker.value.switchToSelectMode()
    } else if (typeof activeTool.value === 'function') {
      activeMarker.value.createMarker(activeTool.value)
    }
  }

  const clearSelection = () => {
    if (!activeMarker.value) {
      return
    }

    activeMarker.value.deselectEditor()
    activeMarker.value.deleteSelectedMarkers()
  }

  return {
    activeMarker,
    activeTool,
    isVisibleMenu,
    scalingMode,
    clearSelection,
    setActiveMarker,
    setActiveTool,
    triggerToolUpdate,
    showMenu: (value: boolean) => (isVisibleMenu.value = value),
    toggleMenu: () => (isVisibleMenu.value = !isVisibleMenu.value),
  }
}
